export default "__VITE_ASSET__DMobCUei__"